import strings from 'strings';

const normalizeText = value => (typeof value === 'string' ? value.trim() : '');

const getDetailValue = (entity, key) =>
  normalizeText(entity?.[key]) || normalizeText(entity?.[`${key}_title`]);

const getDetailLabel = ({ industry, specialty, subspecialty }) =>
  [
    industry && strings.map.entityInfo.specialtyDetails.industryLabel,
    specialty && strings.map.entityInfo.specialtyDetails.specialtyLabel,
    subspecialty && strings.map.entityInfo.specialtyDetails.subspecialtyLabel
  ]
    .filter(Boolean)
    .join(strings.map.entityInfo.specialtyDetails.separator);

/**
 * Normalizes specialty fields returned by both legacy and current map endpoints.
 *
 * @param {Object} entity
 * @returns {{industry: string, specialty: string, subspecialty: string, details: string, detailsLabel: string}}
 */
export const getSpecialtyDetails = entity => {
  const industry = getDetailValue(entity, 'industry');
  const specialty = getDetailValue(entity, 'specialty');
  const subspecialty = getDetailValue(entity, 'subspecialty');
  const values = [industry, specialty, subspecialty].filter(Boolean);

  return {
    industry,
    specialty,
    subspecialty,
    details: values.join(strings.map.entityInfo.specialtyDetails.separator),
    detailsLabel: getDetailLabel({ industry, specialty, subspecialty })
  };
};

/**
 * Preserves the details of every team assigned to a recruiter.
 *
 * @param {Array<Object>} teams
 * @returns {{details: string, detailsLabel: string}}
 */
export const getTeamsSpecialtyDetails = teams => {
  const detailsByTeam = (Array.isArray(teams) ? teams : [])
    .map(getSpecialtyDetails)
    .filter(({ details }) => details);

  return {
    details: detailsByTeam
      .map(({ details }) => details)
      .join(strings.map.entityInfo.specialtyDetails.teamsSeparator),
    detailsLabel: getDetailLabel({
      industry: detailsByTeam.some(({ industry }) => industry),
      specialty: detailsByTeam.some(({ specialty }) => specialty),
      subspecialty: detailsByTeam.some(({ subspecialty }) => subspecialty)
    })
  };
};
